import { types, actions } from './requests'
export const GETMASTER_TYPES = {
    ...types('GETMASTER'),
}
export const GETMASTER_ACTIONS = {
    ...actions('GETMASTER'),
}